/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const AppMessage = {
    LEGAL_DOCUMENTS_TITLE_OK: 'EXITO',
    LEGAL_DOCUMENTS_TITLE_ERROR: 'ERROR AL GUARDAR EL(LOS) DOCUMENTO(S)',
    AUTH_ERROR: 'Error de autorización',
    INVALID_TOKEN: 'El token de autorización ha expirado o es inválido.',
    DOCUMENT_SIGN: 'Firmado de Documentos',
    SIGNATURE_OK: 'El proceso se realizó correctamente',
    SIGNATURE_ERROR: 'No se pudo guardar correctamente la aceptación de los documentos, inténtalo más tarde',
    EMPTY_DOCUMENTS: 'Sin documentos'
}
